import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home'
import About from '../views/About'
import Login from '../views/Login'

Vue.use(Router)

const requireAuth = (to, _from, next) => {
  if (!window.localStorage.getItem('ResNetAppToken')) {
    next({
      name: 'login',
      query: { redirect: to.name }
    })
  } else {
    next()
  }
}

const afterAuth = (_to, from, next) => {
  if (window.localStorage.getItem('ResNetAppToken')) {
    next(from.path)
  } else {
    next()
  }
}

export default new Router({
  mode: 'history',
  base: __dirname,
  routes: [
    { path: '/', redirect: { name: 'dashboard' } },
    { path: '/dashboard', name: 'dashboard', component: Home, beforeEnter: requireAuth },
    { path: '/sabre-price-widget/:hotelId', name: 'about', component: About, beforeEnter: requireAuth },
    { path: '/login', name: 'login', component: Login, beforeEnter: afterAuth },
    { path: '*', redirect: '/' }
  ]
})
